/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByEmotionsKind = (typeof GroupByEmotionsKind)[keyof typeof GroupByEmotionsKind];

export const GroupByEmotionsKind = {
  emotions: 'emotions',
} as const;
